import {ChangeDetectionStrategy, Component, Input, OnChanges, SimpleChanges, ViewChild} from "@angular/core";
import {Cohort} from "../../model/cohort";
import {Trial} from "../../model/trial";

@Component({
  selector: 'gen-trial-viewer',
  templateUrl: './trial-viewer.component.html',
  styleUrls: ['./trial-viewer.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TrialViewerComponent implements OnChanges {

  @Input() trial: Trial;
  @Input() curationStatus: string;    // draft, waitforapproval, approved, rejected
  @ViewChild('top', {static: false}) target: any;

  constructor() {
  }

  ngOnChanges(changes: SimpleChanges) {
  }

  public showTop() {
    const elementList = document.querySelectorAll('.trial-viewer-top');
    if (elementList.length > 0) {
      const element = elementList[0] as HTMLElement;
      element.scrollIntoView({behavior: 'smooth'});
    }
  }

  public showCohort(cohort: Cohort) {
    if (!cohort && this.trial.profile.cohorts.length > 0) {
      cohort = this.trial.profile.cohorts[0];
    }
    let index = this.trial.profile.cohorts.indexOf(cohort);

    const elementList = document.querySelectorAll('.cohort-anchor');
    if (index < elementList.length) {
      const element = elementList[index] as HTMLElement;
      element.scrollIntoView({behavior: 'smooth'});
    }
  }
}
